// CONSTANTS are all caps.
const NS = "CareSlider";
const CLS = "careSlider";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/careSlider.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import { loadCareSliderItem } from '../loadWg/careSliderItem';

export class CareSlider {

	constructor($el) {
		// $el is the widget node return by the loadCareSlider function
		this.$el = $el;
		this.currentSlideIndex = -1;
		this.slideToBeShownAtInit = 0;
	}

	init() {
		this.setCareSlider();
		this.setCareSliderItem();
	}

	isDesktopSize() {
	    return window.innerWidth >= 1200;
    }

	setCareSliderItem() {
        loadCareSliderItem(this.$el, true).then((wgAll) => {
			wgAll ? wgAll.forEach(wg => {
				wg.init();
			}) : '';
		});
    }

    isSlickSlider(slideIndex) {
	    return this.getSlideWrapper(slideIndex).hasClass('slick-slider');
    }

    getSlideWrapper(slideIndex) {
	    return $(this.$el).find('.careSlider-slide').eq(slideIndex).find('.careSliderItem-slides');
    }

    // Reset the slick slider to be original element.
    unslick(slideIndex) {
	    this.getSlideWrapper(slideIndex).slick('unslick');
    }

    // Apply slick slider for an element.
    applySlick(slideIndex) {
	    this.getSlideWrapper(slideIndex).slick({
            arrows: false,
			dots: true,
			responsive: [
				{
					breakpoint: 1999,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1,
						centerMode: true,
					  	centerPadding: '80px'
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						centerMode: true,
						centerPadding: '20px'
					}
				}
			]
        });
    }

	// Show a care slide at a specific index.
	showSlideItemAtIndex(index) {
	    if(index === this.currentSlideIndex) return;

	    let wg = $(this.$el);

	    // Hide the current slide.
	    if(this.currentSlideIndex >= 0) {
            wg.find('.careSlider-slide').eq(this.currentSlideIndex).removeClass('is-open');
            wg.find('.careSlider-itemTitle').eq(this.currentSlideIndex).removeClass('is-open');
        }

        // Show the user's selected slide.
        if(index >= 0) {
	        wg.find('.careSlider-slide').eq(index).addClass('is-open');
            let itemTitle = wg.find('.careSlider-itemTitle').eq(index);
	        itemTitle.addClass('is-open');
            wg.find('.careSlider-selectTitle').text(itemTitle.text());
        }

        // On mobile size ? Create slick slider.
        if(!this.isDesktopSize()) {
	        if(this.currentSlideIndex >= 0) this.unslick(this.currentSlideIndex);
            this.applySlick(index);
        }

        this.currentSlideIndex = index;
    }

	setCareSlider() {

	    let wg = $(this.$el);
    	let isDraging = false;
    	let prevClientX = null;
    	let pointer = wg.find('.careSlider-drag');
    	let circleWrapper = wg.find('.careSlider-circleWrapper');
    	let pointerWidth = pointer.outerWidth();
    	let parentWidth = pointer.parent().outerWidth();
    	let maxWidth = parentWidth - pointerWidth;
    	let circleWidth = circleWrapper.find('.careSlider-circle').eq(0).outerWidth();
    	let circleCount = circleWrapper.find('.careSlider-circle').length;

    	// The space between slide circles, used for calculating the nearest item when user drags the pointer.
    	let spaceBetweenCircle = (parentWidth - circleWidth) / (circleCount - 1);

    	// A padding ensuring the pointer is always at the bottom center of the slide circle.
    	let padding = (circleWidth - pointerWidth) / 2;

        pointer.css('left', padding + 'px');

        this.showSlideItemAtIndex(this.slideToBeShownAtInit);

        // User stops dragging.
	    pointer.mousedown((e) => {
	        if(!this.isDesktopSize()) return;
            prevClientX = e.clientX;
	        isDraging = true;
        })

        // On mobile, user chooses one item from dropdown.
        // System changes content of image slider based on user's selection.
        wg.find('.careSlider-select').change((e) => {
	        this.showSlideItemAtIndex(e.currentTarget.selectedIndex);
        });

	    // User resizes the window.
        // System ensures that all images are shown in desktop size
        // and image slider is used for mobile size.
	    $(window).resize((e) => {
	        if(this.isDesktopSize() && this.isSlickSlider(this.currentSlideIndex))
	            this.unslick(this.currentSlideIndex);
	        if(!this.isDesktopSize() && !this.isSlickSlider(this.currentSlideIndex))
	            this.applySlick(this.currentSlideIndex);
        });

        // User finishes dragging the pointer,
        // system moves pointer to the nearest item and display corresponding slide.
	    $(document).mouseup((e) => {
	        if(!isDraging) return;
            isDraging = false;

            let left = parseInt(pointer.css('left'));
            let space = Math.floor(left % spaceBetweenCircle);
            if(space == 0) return;

            let newLeft = 0;

            // Nearest item is on left ?
            if(space < spaceBetweenCircle / 2) newLeft = left - space + padding;

            // Nearest item is on right ?
            else newLeft = left + (spaceBetweenCircle - space) + padding;

            pointer.animate({left: newLeft});

            let index = Math.floor(newLeft / spaceBetweenCircle);
            this.showSlideItemAtIndex(index);
        })

        // User uses mouse to drag the pointer,
        // system check and ensure pointer doesn't go out of its container.
        $(document).mousemove((e) => {

            if(!isDraging) return;

            let diff = e.clientX - prevClientX;

            let left = parseInt(pointer.css('left'));
            let newLeft = left + diff;

            // Ensure the pointer does not go off the right border.
            if(newLeft >= maxWidth - padding) newLeft = maxWidth - padding;

            // Ensure the pointer does not go off the left border.
            if(newLeft < padding) newLeft = padding;

            pointer.css('left',newLeft + 'px');

            prevClientX = e.clientX;
        })
	}
}
